export const types = {
  PROGRESS_SUCCESS: 'PROGRESS_SUCCESS',
  PROGRESS_ERROR: 'PROGRESS_ERROR',
  PROGRESS_PENDING: 'PROGRESS_PENDING',
  PROGRESS_INACTIVE: 'PROGRESS_INACTIVE'
}



// WEBPACK FOOTER //
// ./src/features/progressBar/store/types.js